<div class="w-full h-full p-2">
    <app-tool-loader [isLoading]="!viewModel()" [positionUnset]="true">
        <p-scrollPanel [style]="{ width: '100%', height: '100%' }">
        @if (viewModel(); as vm) {
            <div class="flex flex-col gap-3">
                <!-- Header with metadata -->
                 @if(!isConstantGradient) {
                    <div class="flex justify-between items-center">
                        <div>
                            @if (vm.mudlineDepth !== undefined && vm.mudlineDepth !== null) {
                            <label class="block text-sm font-medium text-gray-600">Mudline Depth: {{ vm.mudlineDepth | number: '1.0-2' }} {{
                                depthUnit }}</label>
                            }
                            <label class="text-sm font-medium">Total Depth: {{ vm.totalDepthTvd | number: '1.0-2' }} {{ depthUnit }} TVD</label>
                        </div>
                        <!-- Save feedback - using signals for state -->
                        <!-- <div class="text-sm">
                            @if (saving()) { <span class="text-blue-600">Saving...</span> }
                            @if (saveSuccess()) { <span class="text-green-600">✓ Saved</span> }
                            @if (saveError()) { <span class="text-red-600">✗ Error</span> }
                        </div> -->
                    </div>
                }

                <!-- Validation errors from backend -->
                @if (allValidationErrors().length > 0) {
                <div class="flex flex-col gap-2">
                    @for (error of allValidationErrors(); track $index) {
                    <p-message severity="error" [text]="error" styleClass="w-full" />
                    }
                </div>
                }

                <!-- Mode selector -->
                <div class="flex flex-col gap-1">
                    <div>
                        <label class="text-sm font-medium">Specify UDT as</label>
                        <i 
                            class="pi pi-info-circle cursor-help pl-1" 
                            pTooltip="Specify UDT as either Constant Gradient or Custom points."
                        ></i>
                    </div>
                    <p-selectButton [options]="[{label: 'Gradient', value: true}, {label: 'Custom', value: false}]"
                        [(ngModel)]="isConstantGradient" [allowEmpty]="false" />
                </div>

                <!-- Form content -->
                <form [formGroup]="form" class="flex flex-col gap-4">
                    <!-- Constant Gradient child component -->
                    <app-udt-constant-gradient-v2 [hidden]="!isConstantGradient" formControlName="constantGradient"
                        [viewModel]="vm.constantGradient" [userUnits]="userUnits" [totalDepth]="vm.totalDepthTvd" [mudlineDepth]="vm.mudlineDepth"/>

                    <!-- Custom Points child component -->
                    <app-udt-custom-points-v2 [hidden]="isConstantGradient" formControlName="customPoints"
                        [viewModel]="vm.custom" [userUnits]="userUnits" (resetClicked)="handleResetCustomPoints()"/>

                    <!-- Temperature interpolator (read-only display) -->
                    <hr class="my-2" />
                    <app-udt-temperature-interpolator [tempUnit]="tempUnit" [depthUnit]="depthUnit" [totalDepth]="{ trueVerticalDepth: vm.totalDepthTvd, measuredDepth: vm.totalDepthMd }" [refresh$]="refreshInterpolator$" />
                </form>
            </div>
        }
        </p-scrollPanel>
    </app-tool-loader>
</div>
